export function base64ToFile(
  base64: string,
  fileName: string,
  mimeType: string,
): File {
  const binaryString = atob(base64.split(",")[1]);
  const uint8Array = Uint8Array.from(binaryString, (char) =>
    char.charCodeAt(0),
  );

  return new File([uint8Array], fileName, { type: mimeType });
}
